import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import languageLocale from 'utils/LanguageLocale';
import productUtils from 'utils/product';
import Accordion from 'components/ProductPage/Accordion/Accordion';
import RwdProductPageEN from 'components/ProductPage/locales/RwdProductPage_en_US';
import RwdProductPageFR from 'components/ProductPage/locales/RwdProductPage_fr_CA';

const getText = text => languageLocale.getLocalisedDataFromResource(RwdProductPageEN, RwdProductPageFR)(text);

const SKINCARE_CATEGORY_ID = 'cat150006';

function ProductDisclosures({ parentCategory, show, content }) {
    const isCanada = languageLocale.isCanada();

    if (!show || isCanada) {
        return null;
    }

    const isSkincare = productUtils.findProductRootParentCategoryId(parentCategory) === SKINCARE_CATEGORY_ID;

    if (!isSkincare || !content || typeof content !== 'string') {
        return null;
    }

    return (
        <Accordion
            title={getText('productDisclosures')}
            id='productdisclosures'
            dataAt={Sephora.debug.dataAt('product_disclosures_btn')}
        >
            <div
                data-at={Sephora.debug.dataAt('product_disclosures_section')}
                dangerouslySetInnerHTML={{ __html: content }}
            />
        </Accordion>
    );
}

ProductDisclosures.shouldUpdatePropsOn = ['parentCategory', 'show', 'content'];

export default wrapFunctionalComponent(ProductDisclosures, 'ProductDisclosures');
